export default "__VITE_ASSET__D9VPL$Si__"